import store from '@/store'

const { body } = document
const WIDTH = 1280 // refer to Bootstrap's responsive design
export default {
  computed: {
    screen() {
      return this.$store.state.app.screen
    }
  },
  watch: {
    $route(route) {
      route
      if (this.screen === 'small') store.dispatch('app/toggleScreen', 'small')
    }
  },
  beforeMount() {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted() {
    const isMobile = this.$_isMobile()
    if (isMobile) {
      store.dispatch('app/toggleScreen', 'small')
    }
  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile() {
      //Element.getBoundingClientRect() 方法返回元素的大小及其相对于视口的位置。
      //  https://developer.mozilla.org/zh-CN/docs/Web/API/Element/getBoundingClientRect
      const rect = body.getBoundingClientRect()
      return rect.width - 1 < WIDTH
    },
    $_resizeHandler() {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        store.dispatch('app/toggleScreen', isMobile ? 'small' : 'large')
      }
    }
  }
}
